import { render } from "./add-products-category.vue?vue&type=template&id=17eb03f1&scoped=true"
import script from "./add-products-category.vue?vue&type=script&lang=js"
export * from "./add-products-category.vue?vue&type=script&lang=js"

import "./add-products-category.vue?vue&type=style&index=0&id=17eb03f1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\tatsa\\Desktop\\PROJETS\\SUFOSERVICES\\sufo-webadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17eb03f1"]])

export default __exports__